import { arrayOf, number, object, func } from 'prop-types'
import React, { Fragment } from 'react'
import HrbTranslate from '../../../components/language/HrbTranslate'
import ScrollingListBox from '../../../components/library/common/ScrollingListBox'
import AvailableCheckboxItem from './AvailableCheckboxItem'

const AvailableOfficesListBox = props => {

    const { availableOffices, checkedOfficeIds, onCheckedOfficesChanged } = props

    const handleOfficeChecked = (officeId, checked) => {
        let selected = checkedOfficeIds ? [...checkedOfficeIds] : []

        if (checked === true) {
            // add officeId to selection list
            if (selected.indexOf(officeId) === -1) {
                selected.push(officeId);
            }
        } else {
            // remove officeId from selection list
            let index = selected.indexOf(officeId)
            if (index !== -1) {
                selected.splice(index, 1)
            }
        }

        // let somebody know!
        if (onCheckedOfficesChanged) {
            onCheckedOfficesChanged(selected)
        }
    }

    return (
        <div className='column is-5'>
            <em className='p2 mb-3'><HrbTranslate text='AssociateOfficesModal.AvailableOffices' /></em>
            <ScrollingListBox elementId='list-available-offices' className='office-list'>
                {!availableOffices &&
                    <Fragment>
                        <AvailableCheckboxItem />
                        <AvailableCheckboxItem />
                        <AvailableCheckboxItem />
                        <AvailableCheckboxItem />
                        <AvailableCheckboxItem />
                    </Fragment>
                }
                {availableOffices && availableOffices.map(o =>
                    <AvailableCheckboxItem
                        key={o.id}
                        id={o.id}
                        label={`${o.id} - ${o.name}`}
                        checked={checkedOfficeIds.includes(o.id)}
                        onCheckChanged={handleOfficeChecked} />
                )}
            </ScrollingListBox>
        </div>
    )
}

AvailableOfficesListBox.propTypes = {
    availableOffices: arrayOf(object),
    checkedOfficeIds: arrayOf(number),
    onCheckedOfficesChanged: func
}

export default AvailableOfficesListBox